import { useEffect, useState } from "react";
import Moment from "moment";

export default function useAutoUpdateOnTimeout(messages, atdArray, tmnoreply) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (tmnoreply <= 0) return;

    const shouldStartTimer = atdArray.some((call) => {
      const msgs = messages[call.idatendimento];
      if (!msgs || msgs.length === 0) return false;

      const lastMsg = msgs[msgs.length - 1];
      const isLastFromClientOrGestor = lastMsg.author !== "Me";
      const lastDate = Moment(lastMsg.dataenvio, "DD/MM/YYYY HH:mm:ss").format(
        "MM/DD/YYYY HH:mm:ss"
      );
      const diff = Moment().diff(lastDate, "seconds");

      return isLastFromClientOrGestor && diff < tmnoreply;
    });

    if (!shouldStartTimer) return;

    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [messages, atdArray, tmnoreply]);

  return tick;
}
